module.exports = __webpack_public_path__ + "img/datepicker_img.bb81b482.svg";